import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const createRouter = () => new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		
		{
			path: '/login',
			name: 'login',
			component: () => import( '@/views/login.vue'),
			meta:{
				keepAlive: false
			}
		}
	]
})

const router = createRouter()

export function resetRouter () {
	
	const newRouter = createRouter()
	
	router.matcher = newRouter.matcher
	
}

export default router

